import { useState } from "react";
import CardFrameImage from "../images/card-frame.png";

const CardFrameSurface = ({ children, className = "", style }) => {
  const [frameState, setFrameState] = useState("loading");

  return (
    <div
      className={`relative aspect-[648/1000] overflow-hidden rounded-[10%/6.5%] bg-[#ffe252] ${className}`}
      data-card-frame-state={frameState}
      style={style}
    >
      <div
        aria-hidden="true"
        data-testid="card-frame-fallback"
        className="pointer-events-none absolute inset-x-[7%] bottom-[15%] top-[5%] rounded-[5%] bg-white"
      />

      <img
        src={CardFrameImage}
        alt=""
        aria-hidden="true"
        className={`absolute inset-0 z-10 h-full w-full object-contain transition-opacity duration-150 ${
          frameState === "loaded" ? "opacity-100" : "opacity-0"
        }`}
        onError={() => setFrameState("error")}
        onLoad={() => setFrameState("loaded")}
      />

      <div className="relative z-20 h-full w-full">{children}</div>
    </div>
  );
};

export default CardFrameSurface;
